{
    "ChangeUserAgent_Title": "Definir perfil de apresentação do browser",
    "ChangeUserAgent_SubTitle": "Selecione o perfil de apresentação do browser no qual deseja visualizar o conteúdo da página da web durante sua sessão atual neste computador.",
    "ChangeUserAgent_FieldName_BrowserProfile": "Perfil do browser",
    "ChangeUserAgent_Options_ForceAutomaticBrowserDetection": "[Forçar detecção automática do browser]",
    "ChangeUserAgent_FooterActions_Apply": "Aplicar",
    "ChangeUserAgent_FooterActions_Cancel": "Cancelar",
    "NAME": "ChangeUserAgentLanguage"
}